<template>
  <div class="agent-detail">
    <el-tabs v-model="activeTab" class="detail-tabs">
      <el-tab-pane name="basic">
        <template #label>
          <div class="flex items-center">
            <el-icon class="mr-1"><Setting /></el-icon>
            <span>基础配置</span>
          </div>
        </template>
        
        <div class="space-y-4 pt-4">
          <!-- 基本信息 -->
          <el-card shadow="never" class="border-none">
            <template #header>
              <div class="flex items-center font-semibold text-gray-700">
                <el-icon class="mr-2 text-primary"><InfoFilled /></el-icon>
                <span>基本信息</span>
              </div>
            </template>
            <el-descriptions :column="2" border>
              <el-descriptions-item v-for="item in basicInfo" :key="item.label" :label="item.label">
                <template v-if="item.label === '状态'">
                  <el-tag :type="target?.status === 'active' ? 'success' : 'info'" size="small">
                    {{ item.value }}
                  </el-tag>
                </template>
                <template v-else>
                  {{ item.value }}
                </template>
              </el-descriptions-item>
            </el-descriptions>
          </el-card>

          <!-- 提示词配置 -->
          <el-card shadow="never" class="border-none">
            <template #header>
              <div class="flex items-center font-semibold text-gray-700">
                <el-icon class="mr-2 text-primary"><ChatLineRound /></el-icon>
                <span>提示词配置</span>
              </div>
            </template>
            <div class="whitespace-pre-wrap p-4 bg-gray-50 rounded-lg text-gray-600 text-sm leading-relaxed border border-gray-100">
              {{ target?.prompt || '暂无提示词' }}
            </div>
          </el-card>
        </div>
      </el-tab-pane>

      <el-tab-pane name="members">
        <template #label>
          <div class="flex items-center">
            <el-icon class="mr-1"><User /></el-icon>
            <span>成员</span>
          </div>
        </template>
        <div class="pt-4">
          <el-table :data="target?.members || []" border stripe size="small">
            <el-table-column label="成员" min-width="150">
              <template #default="{ row }">
                <div class="flex items-center">
                  <el-avatar :size="28" :src="row.avatar" class="mr-2">
                    {{ row.nickName?.charAt(0) }}
                  </el-avatar>
                  <span class="text-gray-700 font-medium">{{ row.nickName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="role" label="角色" width="100">
              <template #default="{ row }">
                <el-tag size="small" effect="plain">{{ row.role }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template #default="{ row }">
                <span class="text-gray-500 text-xs">{{ row.status }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="加入时间" width="160" />
          </el-table>
        </div>
      </el-tab-pane>

      <el-tab-pane name="chats">
        <template #label>
          <div class="flex items-center">
            <el-icon class="mr-1"><ChatDotRound /></el-icon>
            <span>聊天</span>
          </div>
        </template>
        <div class="pt-4">
          <el-table :data="target?.chats || []" border stripe size="small">
            <el-table-column label="名称" min-width="150">
              <template #default="{ row }">
                <div class="flex items-center">
                  <el-avatar :size="28" :src="row.avatar" class="mr-2">
                    {{ row.name?.charAt(0) }}
                  </el-avatar>
                  <span class="text-gray-700 font-medium">{{ row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型" width="150">
              <template #default="{ row }">
                <span class="text-gray-500 text-xs">{{ row.type }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="创建时间" width="160" />
          </el-table>
        </div>
      </el-tab-pane>

      <el-tab-pane name="signals">
        <template #label>
          <div class="flex items-center">
            <el-icon class="mr-1"><Connection /></el-icon>
            <span>信号</span>
          </div>
        </template>
        <div class="pt-8 text-center text-gray-400">
          <el-empty :image-size="100" description="信号内容开发中..." />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { 
  InfoFilled, 
  ChatLineRound, 
  Setting, 
  User, 
  ChatDotRound, 
  Connection 
} from '@element-plus/icons-vue'

const props = defineProps({
  target: {
    type: Object,
    default: null,
  },
})

// 性别映射
const genderMap = {
  male: '男',
  female: '女',
  neutral: '中性'
}

// 状态映射
const statusMap = {
  active: '启用',
  inactive: '禁用'
}

// 基本信息描述列表数据
const basicInfo = computed(() => {
  if (!props.target) return []

  return [
    {
      label: 'Agent名称',
      value: props.target.name
    },
    {
      label: '性别',
      value: genderMap[props.target.gender] || '-'
    },
    {
      label: '类型',
      value: props.target.type || '-'
    },
    {
      label: '状态',
      value: statusMap[props.target.status] || '-'
    },
    {
      label: '模型',
      value: props.target.model
    },
    {
      label: '提供商',
      value: props.target.provider
    },
    {
      label: '语音ID',
      value: props.target.voiceId || '-'
    },
    {
      label: '创建时间',
      value: props.target.createdAt
    },
    {
      label: '更新时间',
      value: props.target.updatedAt || '-'
    }
  ]
})
</script>
